import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { TemplatesServiceModule } from '..';
import { TemplatesFilterComponent } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
    TemplatesServiceModule
  ],
  declarations: [TemplatesFilterComponent],
  exports: [TemplatesFilterComponent],

})
export class TemplatesFilterComponentModule { }
